import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
  currentPath?: string;
  children: React.ReactNode;
  className?: string;
}

const Layout: React.FC<LayoutProps> = ({
  currentPath = '/',
  children,
  className,
}) => {
  return (
    <div
      className={`min-h-screen flex flex-col ${className || ''}`}
      style={{ backgroundColor: 'var(--color-background-secondary)' }}
    >
      <Header currentPath={currentPath} />
      <main className='flex-1 max-w-none mx-auto py-8 px-6 sm:px-8 lg:px-12 xl:px-16'>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
